export enum TableListItemActionsBlockLocations {
  Left = 'simx-actions-block-left',
  Right = 'simx-actions-block-right',
}
